<template>
  <a-modal
    v-model:visible="logVisible"
    title="日志"
    :footer="null"
    :width="800"
  >
    <a-table
      :dataSource="logData"
      :columns="logColumns"
      :pagination="false"
      :scroll="{ y: 390 }"
      size="small"
    >
      <template #bodyCell="{ column, index }">
        <template v-if="column.key === 'no'">
          {{ index + 1 }}
        </template>
      </template>
    </a-table>
  </a-modal>
  <div class="collection-container">
    <Filter />
    <Table />
    <Drawer />
  </div>
</template>
<script>
import {
  defineComponent,
  provide,
  reactive,
  toRefs,
  watch,
  onMounted,
  h
} from 'vue'
import {
  addressValidate_countryList_get,
  addressValidate_pageByCondition_post,
  addressValidate_updateStatus_post,
  addressValidate_operateLog_get,
  addressValidate_detail_get,
  addressValidate_edit_post
} from './../../server/modules/9022'
import { common_listLanguageInfo_get } from './../../server/modules/7767'
import Filter from './components/filter.vue'
import Table from './components/table.vue'
import Drawer from './components/drawer.vue'
import { message, notification } from 'ant-design-vue'
import { ruleData } from './ruleData'
export default defineComponent({
  name: 'AddressRule',
  components: { Filter, Table, Drawer },
  setup() {
    const state = reactive({
      isEdit: false,
      alreadySelectLanguage: {},
      languageOptionList: [],
      drawerInfo: {},
      drawerTitle: '',
      drawerVisible: false,
      logVisible: false,
      logData: [],
      logColumns: [
        {
          title: '序号',
          dataIndex: 'no',
          key: 'no',
          width: 80
        },
        {
          title: '操作人',
          dataIndex: 'operator',
          key: 'operator',
          width: 140
        },
        {
          title: '操作内容',
          dataIndex: 'operateContent',
          key: 'operateContent'
        },
        {
          title: '操作时间',
          dataIndex: 'createTime',
          key: 'createTime',
          width: 200
        }
      ],
      searchForm: {
        countryIds: [],
        status: null,
        pageNum: 1,
        pageSize: 20,
        total: 0,
        pages: 0
      },
      countryOptionList: [],
      statusOptionList: [
        {
          label: '启用',
          value: 1
        },
        {
          label: '禁用',
          value: 0
        }
      ],
      dataSource: [],
      columns: [
        {
          title: '序号',
          dataIndex: 'no',
          key: 'no'
        },
        {
          title: '国家',
          dataIndex: 'countryName',
          key: 'countryName'
        },
        {
          title: '状态',
          dataIndex: 'status',
          key: 'status'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          key: 'createTime'
        },
        {
          title: '更新时间',
          dataIndex: 'lastUpdateTime',
          key: 'lastUpdateTime'
        },
        {
          title: '操作',
          dataIndex: 'action',
          key: 'action',
          width: 200
        }
      ],
      checkAll: false,
      yindeterminate: false,
      filterOption: (input, option) => {
        return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
      onChangeAll: () => {
        state.searchForm.countryIds = state.countryOptionList.map(i => i.value)
      },
      onCheckAllChange: () => {
        if (state.checkAll) {
          state.searchForm.countryIds = state.countryOptionList.map(
            i => i.value
          )
        } else {
          state.searchForm.countryIds = []
        }
      },
      reverse: () => {
        const reverseCountry = []
        state.countryOptionList.forEach(i => {
          if (state.searchForm.countryIds.indexOf(i.value) < 0) {
            reverseCountry.push(i.value)
          }
        })
        state.searchForm.countryIds = reverseCountry
      },
      getCountryList: async () => {
        const { success, data } = await addressValidate_countryList_get()
        if (success) {
          state.countryOptionList = data.map(i => {
            return {
              label: i.countryCode
                ? `[${i.countryCode}]${i.countryName}`
                : i.countryName,
              value: i.countryId
            }
          })
        }
      },
      getTableList: async () => {
        const { pageNum, pageSize, status, countryIds } = state.searchForm
        const { success, data } = await addressValidate_pageByCondition_post({
          pageNum,
          pageSize,
          status,
          countryIds
        })
        if (success) {
          state.dataSource = data.list
          state.searchForm.total = data.total
          state.searchForm.pages = data.pages
        } else {
          state.dataSource = []
        }
      },
      changeStatus: async (id, status) => {
        const { success } = await addressValidate_updateStatus_post({
          id,
          status: status === 0 ? 1 : 0
        })
        if (success) {
          message.success(status === 0 ? '启用成功' : '禁用成功')
          state.getTableList()
        } else {
          message.error(status === 0 ? '启用失败' : '禁用失败')
        }
      },
      editDrawerInfo: id => {
        state.isEdit = false
        state.changeDrawer(id)
      },
      viewDrawerInfo: id => {
        state.isEdit = true
        state.changeDrawer(id)
      },
      changeDrawer: async id => {
        const { success, data } = await addressValidate_detail_get({ id })
        if (success) {
          state.drawerInfo = data
          let resRuleList = []
          if (
            data.addressValidateConfigDetailDTOList &&
            data.addressValidateConfigDetailDTOList.length > 0
          ) {
            data.addressValidateConfigDetailDTOList.forEach(i => {
              if (!i.errorPromptDTOList || i.errorPromptDTOList.length === 0) {
                i.errorPromptDTOList = [
                  {
                    lang: 'English',
                    langCode: 'en-GB',
                    prompt: ''
                  }
                ]
              }
              resRuleList.push(i)
            })
          }
          let localRuleList = ruleData
          let newRuleData = localRuleList.map(i => {
            let value = resRuleList.filter(ii => ii.type === i.type)
            if (value.length === 1) {
              return {
                ...i,
                ...value[0]
              }
            } else {
              return {
                ...i
              }
            }
          })
          state.drawerInfo.addressValidateConfigDetailDTOList = newRuleData
          state.drawerVisible = true
          state.drawerTitle = '编辑'
        } else {
          message.error('获取详情失败')
        }
      },
      onPageChange: (page, pageSize) => {
        if (pageSize !== state.searchForm.pageSize) {
          state.searchForm.pageNum = 1
        } else {
          state.searchForm.pageNum = page
        }
        state.searchForm.pageSize = pageSize
        state.getTableList()
      },
      searchFormData: () => {
        state.searchForm.pageNum = 1
        state.searchForm.pageSize = 20
        state.getTableList()
      },
      resetFormData: () => {
        state.searchForm = {
          countryIds: [],
          status: null,
          pageNum: 1,
          pageSize: 20,
          total: 0,
          pages: 0
        }
        state.getTableList()
      },
      showLogModal: async id => {
        const { success, data } = await addressValidate_operateLog_get({ id })
        if (success) {
          state.logData = data
          state.logVisible = true
        }
      },
      getLanguage: async () => {
        const { success, data } = await common_listLanguageInfo_get()
        if (success) {
          state.languageOptionList = data.map(i => {
            return {
              label: i.lang,
              value: i.langCode
            }
          })
        }
      },
      addLanguageItem: index => {
        state.drawerInfo.addressValidateConfigDetailDTOList[
          index
        ].errorPromptDTOList.push({
          langCode: '',
          prompt: ''
        })
      },
      removeLabguageItem: (index, idx) => {
        state.drawerInfo.addressValidateConfigDetailDTOList[
          index
        ].errorPromptDTOList.splice(idx, 1)
      },
      cnacelRequired: index => {
        state.drawerInfo.addressValidateConfigDetailDTOList[
          index
        ].required = null
      },
      submitRules: async () => {
        let englishTipsList = []
        let newAddressValidateConfigDetailDTOList = []
        const pushRuleConfig = (i, index) => {
          if (
            i.required === true ||
            i.required === false ||
            i.appRegularExpression ||
            i.regularExpression ||
            i.webRegularExpression
          ) {
            newAddressValidateConfigDetailDTOList.push(i)
            i.errorPromptDTOList.forEach(ii => {
              if (ii.langCode === 'en-GB' && ii.prompt === '') {
                if (!(i.isShow && !i.showFlag)) {
                  englishTipsList.push(`处理规则${index + 1}的英文提示文案必填`)
                }
              }
            })
          } else if (i.showFlag === true) {
            newAddressValidateConfigDetailDTOList.push(i)
          }
        }
        state.drawerInfo.addressValidateConfigDetailDTOList.forEach(
          (i, index) => {
            if (i.isShow) {
              if (i.showFlag === false) {
                newAddressValidateConfigDetailDTOList.push(i)
              } else if (i.showFlag === true) {
                pushRuleConfig(i, index)
              }
            } else {
              pushRuleConfig(i, index)
            }
          }
        )
        if (englishTipsList.length > 0) {
          notification.error({
            message: '英文提示文案为空',
            description: h('div', {}, [
              h(
                'div',
                englishTipsList.map(item => h('p', `${item}`))
              )
            ])
          })
          return
        }
        let params = state.drawerInfo
        newAddressValidateConfigDetailDTOList.forEach(i => {
          let newDTOList = i.errorPromptDTOList.filter(
            ii => ii.langCode && ii.prompt
          )
          i.errorPromptDTOList = newDTOList
        })
        params.addressValidateConfigDetailDTOList = newAddressValidateConfigDetailDTOList
        const { success } = await addressValidate_edit_post(params)
        if (success) {
          message.success('编辑地址策略成功')
          state.drawerVisible = false
          state.getTableList()
        } else {
          message.error('编辑地址策略失败，请稍后重试')
        }
      }
    })
    watch(state.searchForm, newVal => {
      let countryIds = newVal.countryIds
      if (countryIds.length === 0) {
        state.checkAll = false
        state.yindeterminate = false
      } else if (
        countryIds.length === state.countryOptionList.length &&
        countryIds.length !== 0
      ) {
        state.checkAll = true
        state.yindeterminate = false
      } else if (
        countryIds.length < state.countryOptionList.length &&
        countryIds.length > 0
      ) {
        state.checkAll = false
        state.yindeterminate = true
      }
    })
    watch(
      () => state.drawerInfo.addressValidateConfigDetailDTOList,
      newVal => {
        newVal.forEach(i => {
          state.alreadySelectLanguage[i.type] = i.errorPromptDTOList.map(
            ii => ii.langCode
          )
        })
      },
      { deep: true }
    )
    provide('initState', state)
    onMounted(() => {
      state.getCountryList()
      state.getTableList()
      state.getLanguage()
    })
    return {
      ...toRefs(state)
    }
  }
})
</script>
<style scoped>
.collection-container {
  margin: 20px;
  padding: 20px;
  overflow: hidden;
  background: #ffffff;
}
</style>
